export const HEXAGRAM_DATA = [
    {
        "number": 1,
        "name": {
            "chinese": "乾",
            "pinyin": "qián",
            "english": "The Creative"
        },
        "bits": [
            1,
            1,
            1,
            1,
            1,
            1
        ],
        "upper": "qian",
        "lower": "qian",
        "judgment": "The Creative works sublime success, furthered by perseverance. Here is the primal power that gives rise to all things and carries them through to completion. To align oneself with its tireless, generative force is to find the way open and the outcome assured.",
        "image": "Heaven moves above heaven, ceaseless and untiring in its course. Thus the noble person makes themselves strong and inexhaustible, never resting in the work of self-renewal.",
        "gloss": "Pure creative force, untiring and bright",
        "lineTexts": [
            "The dragon lies hidden beneath the waters; its hour has not yet come. Wait without acting, for the time to rise is not yet ripe.",
            "The dragon appears in the field, and the great one becomes visible. It is fitting now to seek the counsel of someone of true stature.",
            "All day the noble person is creatively active, and at nightfall still wakeful and wary. The work is full of danger, yet to remain blameless is possible.",
            "Hovering over the deep, the dragon may leap upward or may stay below. At this turning point either choice can be faultless if it springs from sincerity.",
            "The dragon flies in the heavens; the great one comes into their full power. It furthers one now to seek the worthy and let influence radiate.",
            "The arrogant dragon climbs too high and will have cause to repent. What rises beyond its measure has nowhere left to go but down."
        ]
    },
    {
        "number": 2,
        "name": {
            "chinese": "坤",
            "pinyin": "kūn",
            "english": "The Receptive"
        },
        "bits": [
            0,
            0,
            0,
            0,
            0,
            0
        ],
        "upper": "kun",
        "lower": "kun",
        "judgment": "The Receptive brings sublime success through the perseverance of a mare. If the noble person sets out to lead, they go astray; following, they find their guide. To yield, to bear, and to complete what the creative begins is the way that brings good fortune.",
        "image": "The earth in its breadth lies open beneath the whole of heaven, sustaining all that lives. Thus the noble person broadens their nature and carries the outer world with a capacity as wide as the ground itself.",
        "gloss": "Devoted yielding that sustains all things",
        "lineTexts": [
            "When hoarfrost is underfoot, solid ice is not far off. Heed the first faint sign, for small beginnings ripen into great conditions.",
            "Straight, square, and great by nature, the right way needs no contriving. Acting without forethought, nothing remains that is not furthered.",
            "Hidden lines are kept; one may persevere quietly. If called to serve another's work, complete it without claiming the glory.",
            "A tied-up sack lets nothing in and nothing out. In a guarded time, keeping silent brings neither praise nor blame.",
            "A yellow lower garment brings supreme good fortune. True worth that abides at the center and makes no display is most blessed of all.",
            "Dragons battle in the meadow, and their blood is black and yellow. When the yielding contends with the strong as an equal, both suffer the wound."
        ]
    },
    {
        "number": 3,
        "name": {
            "chinese": "屯",
            "pinyin": "zhūn",
            "english": "Difficulty at the Beginning"
        },
        "bits": [
            1,
            0,
            0,
            0,
            1,
            0
        ],
        "upper": "kan",
        "lower": "zhen",
        "judgment": "Difficulty at the beginning works sublime success through perseverance. Do not undertake anything rashly; instead, seek out helpers and set things in order. As the first green struggles through hard ground, what is tangled at the start can still grow straight if rightly tended.",
        "image": "Clouds and thunder gather, the storm not yet broken into rain. So in confusion the noble person brings shape to disorder, untangling the threads and setting each in its place.",
        "gloss": "First sprouting through chaos and resistance",
        "lineTexts": [
            "Held back at the threshold, it is right to pause rather than press on. Remaining steadfast and gathering allies prepares the ground for what follows.",
            "Difficulties pile up; the horse and wagon turn back. The maiden does not pledge herself now but waits ten years before the union ripens.",
            "Hunting deer without a guide, one only strays deeper into the forest. The wise see this and let it go, for to push ahead would bring humiliation.",
            "Horse and wagon turn back once more, yet now one should go to seek the union. Reaching toward a worthy helper, the way ahead opens favorably.",
            "When the gifts one would give are still held back by circumstance, scatter blessing in small measure. To force great works now invites misfortune; modest constancy prevails.",
            "Horse and wagon part ways, and bloody tears flow. At the summit of difficulty, what cannot be sustained must be released, and grief gives way at last."
        ]
    },
    {
        "number": 4,
        "name": {
            "chinese": "蒙",
            "pinyin": "méng",
            "english": "Youthful Folly"
        },
        "bits": [
            0,
            1,
            0,
            0,
            0,
            1
        ],
        "upper": "gen",
        "lower": "kan",
        "judgment": "Youthful folly meets with success. It is not I who seek the inexperienced; the inexperienced seeks me. At the first asking I answer; questioned again and again it becomes pestering, and to the pesterer I give no answer. Perseverance furthers.",
        "image": "At the foot of the mountain a spring wells up, not yet knowing where it will run. Thus the noble person nourishes their character through resolute and thorough conduct, giving the young current its proper course.",
        "gloss": "Inexperience awaiting patient instruction",
        "lineTexts": [
            "To dispel folly, discipline serves well, and fetters may rightly be removed once. But to go on punishing brings only humiliation and hardens the fault.",
            "To bear with the foolish in kindness brings good fortune. To take the inexperienced under one's care, as a household receives its own, brings order to the home.",
            "Do not take this maiden who loses herself at the sight of a man of bronze. Such a one keeps nothing of her own; nothing is gained by the union.",
            "Folly that closes in upon itself, walled off from all teaching, brings humiliation. Cut off from the wise, the mind hardens in its error.",
            "Childlike folly that knows it does not know brings good fortune. The openness of the willing learner draws the help it needs.",
            "In punishing folly, it does not serve to commit further wrong. One should fend off harm, not inflict it, guarding against excess in correction."
        ]
    },
    {
        "number": 5,
        "name": {
            "chinese": "需",
            "pinyin": "xū",
            "english": "Waiting"
        },
        "bits": [
            1,
            1,
            1,
            0,
            1,
            0
        ],
        "upper": "kan",
        "lower": "qian",
        "judgment": "Waiting, if you are sincere, carries light and success; perseverance brings good fortune, and it furthers one to cross the great water. When danger lies ahead, strength does not rush in but bides its time with inner certainty. Nourished by confidence, the one who waits in the right spirit will not wait in vain.",
        "image": "Clouds rise into the heavens, holding the rain that has not yet fallen. So the noble person eats and drinks, is glad and of good cheer, letting the appointed hour arrive in its own time.",
        "gloss": "Patient confidence before the threshold",
        "lineTexts": [
            "Waiting in the open meadow, far from danger, it is well to abide in what endures. Persevering here, one stays free of fault.",
            "Waiting on the sand, the water's edge draws nearer and small talk begins. Though there is minor friction, in the end good fortune comes.",
            "Waiting in the mud, one has come too close and invites the approach of trouble. Caution and watchfulness now keep loss at bay.",
            "Waiting in blood, fallen into the very pit of danger, the only counsel is to keep still. Yielding and composed, one is carried out of the depths.",
            "Waiting at meat and wine, a respite in the midst of trial. Perseverance brings good fortune, and strength is restored for what remains.",
            "Falling into the pit, three uninvited guests arrive unbidden. Receive them with respect, and in the end, good fortune attends what seemed misfortune."
        ]
    },
    {
        "number": 6,
        "name": {
            "chinese": "訟",
            "pinyin": "sòng",
            "english": "Conflict"
        },
        "bits": [
            0,
            1,
            0,
            1,
            1,
            1
        ],
        "upper": "qian",
        "lower": "kan",
        "judgment": "In conflict there is sincerity that is yet obstructed; a cautious halt midway brings good fortune, but carrying it to the bitter end brings misfortune. It furthers one to see the great person; it does not further one to cross the great water. Where strength meets danger, the wise seek a fair settling rather than a final victory.",
        "image": "Heaven rises and water sinks, the two moving in opposite directions and never meeting. Thus the noble person, in all that they undertake, considers the beginning carefully so that strife may be averted before it starts.",
        "gloss": "Strife best resolved before its end",
        "lineTexts": [
            "If one does not prolong the quarrel, there is a little gossip, but in the end good fortune. Let the matter rest early and the dispute dissolves.",
            "Unable to prevail in conflict, one turns back and slips away. A household of three hundred suffers no harm when its head yields in time.",
            "Nourished by ancient virtue, one perseveres in the face of danger and ends in good fortune. Should one serve in a ruler's affairs, claim nothing as one's own.",
            "Unable to win the contest, one turns back to accept fate, changes the heart, and finds peace in steadfastness. Yielding to what is right brings good fortune.",
            "To bring the conflict before a just and impartial judge brings supreme good fortune. Where right is weighed by true authority, the matter is rightly settled.",
            "Even if one is awarded a belt of honor, by the morning's end it is stripped away three times. Victory won through strife cannot be securely held."
        ]
    },
    {
        "number": 7,
        "name": {
            "chinese": "師",
            "pinyin": "shī",
            "english": "The Army"
        },
        "bits": [
            0,
            1,
            0,
            0,
            0,
            0
        ],
        "upper": "kun",
        "lower": "kan",
        "judgment": "The army needs perseverance and a leader of seasoned strength; then there is good fortune and no blame. A multitude must be moved by discipline and a just cause, gathered around one in whom all can place their trust. Force rightly ordered and rightly led brings order; force without these brings ruin.",
        "image": "Water is held within the earth, the deep gathered beneath the field. Thus the noble person, by being generous toward the people, gathers and sustains the multitudes around them.",
        "gloss": "Disciplined strength under trusted command",
        "lineTexts": [
            "An army must set out in good order from the first. Without discipline at the start, even a worthy cause comes to misfortune.",
            "Stationed in the midst of the host, the leader holds the center and earns good fortune without blame. The ruler's threefold favor confirms the trust placed in them.",
            "Should the army carry corpses in the wagon, misfortune follows. When command is divided or unfit, the campaign ends in ruin.",
            "The army retreats and makes camp; there is no blame in withdrawing. To know when not to advance is itself a mark of sound command.",
            "Game is in the field, and it is right to catch it; this brings no blame. Let the eldest lead the host, for if the young and untried command, the wagons bear back the dead.",
            "The great ruler issues commands, founds states, and bestows fiefs on the worthy. Yet inferior people should not be employed, lest the order won be undone."
        ]
    },
    {
        "number": 8,
        "name": {
            "chinese": "比",
            "pinyin": "bǐ",
            "english": "Holding Together"
        },
        "bits": [
            0,
            0,
            0,
            0,
            1,
            0
        ],
        "upper": "kan",
        "lower": "kun",
        "judgment": "Holding together brings good fortune. Inquire of the oracle once more whether you possess constancy, greatness, and endurance; if so, there is no blame. The hesitant who delay arrive too late and meet misfortune; those uncertain gather now, while the moment for union still stands open.",
        "image": "Water flows over the earth, filling every hollow and binding itself to the ground. Thus the ancient kings established the many states and drew the feudal lords into close and trusting bond.",
        "gloss": "Union founded on sincere allegiance",
        "lineTexts": [
            "Hold together with sincerity, and there is no blame. Let truth fill you as a vessel to the brim, and good fortune comes from unlooked-for quarters.",
            "Holding together that arises from within brings good fortune through perseverance. Union that springs from one's own true nature does not lose itself.",
            "To hold together with the wrong people leads nowhere good. Bound to those unworthy, one's loyalty is spent on barren ground.",
            "Holding together with those beyond oneself, openly and outwardly, brings good fortune. To follow the worthy without concealment furthers one.",
            "Manifest holding together, as a king who drives game from only three sides and lets the front go free. The people need no warning and remain at ease; this is good fortune.",
            "Holding together that lacks a head and a guiding center comes to misfortune. Where there is no beginning rightly made, there can be no good end."
        ]
    },
    {
        "number": 9,
        "name": {
            "chinese": "小畜",
            "pinyin": "xiǎo chù",
            "english": "The Taming Power of the Small"
        },
        "bits": [
            1,
            1,
            1,
            0,
            1,
            1
        ],
        "upper": "xun",
        "lower": "qian",
        "judgment": "Success comes, though only in small things. Dense clouds gather from the western edge of the sky, yet no rain has fallen. A single gentle force restrains the strong for a time; the great current is checked but not turned, and one must wait for the moisture to ripen.",
        "image": "Wind drives across the face of Heaven, moving the strong without halting it. Thus the noble person refines the grace of outer form and the brightness of character, perfecting small virtues while the larger work cannot yet be done.",
        "gloss": "The small restrains the strong; clouds without rain",
        "lineTexts": [
            "He returns to his own road. How could there be blame in this? Good fortune lies in turning back to the way that is rightly yours.",
            "Drawn back to the road by the example ahead, he returns willingly and is not led astray. To follow what is fitting brings good fortune.",
            "The spokes burst from the wagon wheels, and husband and wife turn their eyes away from each other. The advance cannot hold; restraint has overcome it from within.",
            "Where there is sincerity, the blood departs and dread gives way. Held in a place of danger, he is trusted by those above, and no fault remains.",
            "He is sincere and binds others to him; with truth he draws his neighbor close, and shares his abundance rather than hoarding it.",
            "The rain comes at last, and the resting place is reached; the small power has had its full effect. Yet the woman who presses on courts danger, and the noble person who acts now invites misfortune."
        ]
    },
    {
        "number": 10,
        "name": {
            "chinese": "履",
            "pinyin": "lǚ",
            "english": "Treading"
        },
        "bits": [
            1,
            1,
            0,
            1,
            1,
            1
        ],
        "upper": "qian",
        "lower": "dui",
        "judgment": "One treads upon the tail of the tiger, yet it does not bite. With cheerful courtesy meeting overwhelming strength, the weak finds passage where force would fail. Conduct that is correct and good-humored carries one safely through danger.",
        "image": "Heaven stands above, the Lake gleams below, each keeping its proper place. Thus the noble person discerns high from low and steadies the will of the people, giving every station the bearing that befits it.",
        "gloss": "Treading the tiger's tail with care",
        "lineTexts": [
            "He walks his simple path and goes forward unencumbered. Without blame, for one who is content with plainness can advance and meet no censure.",
            "He treads a level, even road; the secluded one who keeps to it remains steadfast and finds good fortune. Quiet constancy preserves him.",
            "A one-eyed man thinks he sees clearly, a lame man thinks he can stride; treading on the tiger's tail, he is bitten. Misfortune. The bold who overreach their measure bring ruin.",
            "He treads upon the tiger's tail, but with circumspection and inner dread. In the end, good fortune, for caution turns the danger aside.",
            "He treads resolutely, with full and decided conduct. Even in what is right, hold to awareness of peril; firmness alone must not become rashness.",
            "Look back over the path you have trodden and weigh the signs it bears. When the whole course rounds to completion, supreme good fortune comes."
        ]
    },
    {
        "number": 11,
        "name": {
            "chinese": "泰",
            "pinyin": "tài",
            "english": "Peace"
        },
        "bits": [
            1,
            1,
            1,
            0,
            0,
            0
        ],
        "upper": "kun",
        "lower": "qian",
        "judgment": "The small departs and the great draws near; good fortune and success unfold. Heaven and Earth join in living union, and all beings flourish in the harmony of their mingling. This is the season of flowering, when high and low share one accord.",
        "image": "Earth rests above, Heaven moves below, and their breath flows together in union. Thus the ruler shapes and completes the course of Heaven and Earth, ordering their gifts so as to sustain the people.",
        "gloss": "Heaven and Earth in union; flowering peace",
        "lineTexts": [
            "When the ribbon-grass is pulled, its roots come up entwined together; to set out now brings good fortune, for the worthy rise as one and draw their fellows along.",
            "He bears with the uncultivated, fords the river boldly, neglects nothing distant, and forms no faction. In this way he walks the middle path and honors it.",
            "No plain that does not become a slope, no going forth without a return. Remain steadfast in hardship and feel no grief; trust the fullness given, and enjoy its blessing.",
            "He flutters down, not boasting of his wealth, drawing near to his neighbors in good faith. The high descends to the low with sincere and open heart.",
            "King Yi gives his daughter in marriage, and from this comes blessing and supreme good fortune. The noble yields to the humble, and abundance follows.",
            "The city wall crumbles back into the moat. Use no armies now; let the decree go forth within your own borders. However right, this brings cause for regret, for peace has reached its turning."
        ]
    },
    {
        "number": 12,
        "name": {
            "chinese": "否",
            "pinyin": "pǐ",
            "english": "Standstill"
        },
        "bits": [
            0,
            0,
            0,
            1,
            1,
            1
        ],
        "upper": "qian",
        "lower": "kun",
        "judgment": "Standstill is the work of unworthy ones, and it does not favor the constancy of the noble person. The great departs and the small approaches; Heaven and Earth draw apart, and their breath no longer mingles. This is a time to withhold oneself and not to advance.",
        "image": "Heaven rises away above, Earth sinks away below, and the two no longer meet. Thus the noble person draws in the brightness of his virtue to escape hardship, and will not be tempted by rank or reward.",
        "gloss": "Heaven and Earth estranged; the time of stagnation",
        "lineTexts": [
            "When the ribbon-grass is pulled, its roots come up entwined together; to remain steadfast brings good fortune and success. Withdraw with your own kind and keep faith.",
            "They endure and bear; for the small folk this brings good fortune, while the great man accepts the standstill and so meets success. Do not be swept into the common tide.",
            "He bears his shame in silence, hiding the disgrace he feels. The unworthy, raised beyond their measure, are inwardly troubled by what they cannot uphold.",
            "He acts at the bidding of the highest, and no blame attaches; those who share his purpose partake of the blessing. The turning begins to come.",
            "The standstill draws toward its close, and the great man finds good fortune. Yet he must say, 'It might fail, it might fail,' and bind his security to a cluster of mulberry shoots.",
            "The standstill is overthrown; first there was standstill, afterward there is joy. What stagnated does not endure, for nothing remains forever still."
        ]
    },
    {
        "number": 13,
        "name": {
            "chinese": "同人",
            "pinyin": "tóng rén",
            "english": "Fellowship with Men"
        },
        "bits": [
            1,
            0,
            1,
            1,
            1,
            1
        ],
        "upper": "qian",
        "lower": "li",
        "judgment": "Fellowship gathered in the open field brings success. It furthers one to cross the great water, and to hold to the constancy of the noble person. When union rests on what is clear and common to all, great undertakings may be borne across.",
        "image": "Fire ascends toward Heaven, its light reaching upward to what is high above. Thus the noble person sorts the kindred by their classes and discerns the natures of things, knowing where true fellowship may rest.",
        "gloss": "Open fellowship; union of clear and common purpose",
        "lineTexts": [
            "Fellowship at the gate, in the plain light of the open threshold. No blame, for a union begun without concealment or partiality offends no one.",
            "Fellowship within the clan only. This brings humiliation, for to bind oneself to a narrow circle is to fall short of the open field.",
            "He hides weapons in the thicket and climbs the high hill to watch; for three years he cannot rise to act. Distrust holds him in arms but withholds him from battle.",
            "He mounts upon the wall yet does not press the attack. Good fortune, for he turns back from the quarrel and yields to what is right.",
            "The companions first weep and lament, and afterward they laugh; for after great struggles they come together at last. What is rightly bound cannot be kept apart.",
            "Fellowship in the meadow beyond the walls. No regret, though the union is still incomplete, for the aim is sound even where the full goal is not yet reached."
        ]
    },
    {
        "number": 14,
        "name": {
            "chinese": "大有",
            "pinyin": "dà yǒu",
            "english": "Possession in Great Measure"
        },
        "bits": [
            1,
            1,
            1,
            1,
            0,
            1
        ],
        "upper": "li",
        "lower": "qian",
        "judgment": "Possession in great measure brings supreme success. A single yielding spirit holds the central place, and the strong gather willingly to serve it. When abundance is governed with clarity and humility, the time itself confers good fortune.",
        "image": "Fire blazes high above Heaven, casting its light far over all things. Thus the noble person curbs what is base and ill, and upholds what is good, obeying the benevolent will of Heaven and so ordering the bright fate entrusted to him.",
        "gloss": "Great possession held in clear and humble light",
        "lineTexts": [
            "No dealings yet with what is harmful, and so no blame; if one remains mindful of hardship, the abundance stays free of fault. The beginning is still untested and clean.",
            "A great wagon for the load, and a destination toward which to drive. To set out now is without blame, for ample strength is matched to a worthy aim.",
            "A prince offers his wealth in tribute to the Son of Heaven. The small and grasping man could never do this, for he cannot give what abundance has placed in his hands.",
            "He makes a distinction between himself and his neighbor's display, and keeps within his measure. No blame, for one who does not flaunt his wealth escapes the envy of the powerful.",
            "His sincerity wins over others and meets a like sincerity in return; dignity tempers his approachableness, and good fortune follows. Truth borne with quiet majesty draws all hearts.",
            "He is blessed by Heaven itself. Good fortune; nothing that does not further, for one who in great possession remains modest and devout is sustained from above."
        ]
    },
    {
        "number": 15,
        "name": {
            "chinese": "謙",
            "pinyin": "qiān",
            "english": "Modesty"
        },
        "bits": [
            0,
            0,
            1,
            0,
            0,
            0
        ],
        "upper": "kun",
        "lower": "gen",
        "judgment": "Modesty creates success; the noble person carries his undertaking through to the end. Heaven sends its light downward and shines, and Earth in its lowliness rises upward to meet it. What is high it brings down, what is low it lifts, and the modest are completed in their course.",
        "image": "Within the Earth dwells the Mountain, its great mass hidden beneath the level ground. Thus the noble person draws down from where there is too much and adds to where there is too little, weighing all things and dispensing them with even hand.",
        "gloss": "Greatness held low; the mountain within the earth",
        "lineTexts": [
            "Modest and again modest is the noble person; with such humility he may cross the great water, and good fortune follows. The lowly bearing of the worthy carries him through danger.",
            "Modesty that finds its voice and is seen by all. To persevere brings good fortune, for humility risen to expression rings true to the heart.",
            "The noble person who toils yet stays modest carries his work to completion. Good fortune, for merit joined to humility wins the lasting allegiance of the people.",
            "Nothing that does not further the display of modesty in action. He moves within his bounds and does not transgress the rule, neither shrinking back nor overstepping.",
            "Not boasting of wealth, he draws his neighbors in; it furthers to use force against the unyielding, and nothing fails to further. Even firm measures, taken in humility, are without reproach.",
            "Modesty that finds its voice; it furthers to set the armies marching and to discipline one's own domain. He may correct what lies within his reach, for his humility has earned the right to act."
        ]
    },
    {
        "number": 16,
        "name": {
            "chinese": "豫",
            "pinyin": "yù",
            "english": "Enthusiasm"
        },
        "bits": [
            0,
            0,
            0,
            1,
            0,
            0
        ],
        "upper": "zhen",
        "lower": "kun",
        "judgment": "Enthusiasm favors the appointing of helpers and the setting of armies in motion. When movement follows the line of least resistance, all things fall into their willing place, as Heaven and Earth keep their seasons without strain. So the people gather gladly behind a leader who awakens them.",
        "image": "Thunder bursts forth from the Earth, resounding in glad release. Thus the ancient kings made music to honor merit, offering it in splendor to the Highest and inviting their forefathers to share in it.",
        "gloss": "Thunder rousing the earth; gathered, inspiring joy",
        "lineTexts": [
            "Enthusiasm that gives itself away in display brings misfortune. To boast of one's connections and squander joy in vanity exhausts the source.",
            "Firm as a rock, and not for a single day; to persevere brings good fortune. He neither flatters those above nor scorns those below, but reads the hidden seeds of things.",
            "Enthusiasm that looks upward and waits brings remorse; hesitation, too, brings remorse. One who gazes at the powerful instead of acting loses the moment to delay.",
            "The source from which enthusiasm flows; great things may be achieved. Doubt nothing, for friends gather round him as the hair-clasp draws the strands together.",
            "Persistently ill, and yet he does not die. Constant pressure from above hems him in, yet the central force in him is never wholly quenched.",
            "Enthusiasm grown blind and lost in itself; yet if, when all is done, there is a change of heart, then no blame. Even delusion may be redeemed when it turns back in time."
        ]
    },
    {
        "number": 17,
        "name": {
            "chinese": "隨",
            "pinyin": "suí",
            "english": "Following"
        },
        "bits": [
            1,
            0,
            0,
            1,
            1,
            0
        ],
        "upper": "dui",
        "lower": "zhen",
        "judgment": "Following brings sublime success, and no blame falls where the way is steady and true. To be followed, one must first know how to follow; to lead others, one must first learn to serve the moment. Hold fast to what is right, and the loyalty of others will gather of its own accord.",
        "image": "Thunder lies sleeping within the Lake, and the storm that once stirred now settles into rest. Thus the noble person, when daylight fades, withdraws indoors to renewal and repose, following the rhythm of the hour rather than straining against it.",
        "gloss": "Adapt, and others will follow",
        "lineTexts": [
            "The standard within shifts; what once held firm now yields to a new alignment. Go beyond your own gate to mingle freely, and your dealings will bear fruit.",
            "If you cling to the small child, you let the strong companion slip away. One cannot hold to both at once; choose what is worthy and release the rest.",
            "Holding to the strong man, you let go of the small child. You gain what you truly seek, yet must stay steadfast in your own intent and not be carried off course.",
            "Following draws followers, and influence accumulates. Even rightful gain invites suspicion here; keep to sincerity and clarity of purpose, and no fault will cling to you.",
            "Sincere toward what is good and beautiful, you follow the higher path without wavering. Such constancy brings fortune that needs no defense.",
            "The bond is so firm it seems bound and held fast. The king brings his offering upon the western mountain; devotion this complete is honored at the source itself."
        ]
    },
    {
        "number": 18,
        "name": {
            "chinese": "蠱",
            "pinyin": "gǔ",
            "english": "Work on What Has Been Spoiled"
        },
        "bits": [
            0,
            1,
            1,
            0,
            0,
            1
        ],
        "upper": "gen",
        "lower": "xun",
        "judgment": "Work on what has been spoiled brings supreme success, for decay, faced squarely, becomes the beginning of renewal. It is fitting to cross the great water and undertake the task. Consider three days before the turning point and three days after, for what was let go did not rot in a day, and its mending must be measured.",
        "image": "Beneath the still Mountain the Wind blows low and circling, scattering the things of the world into disorder. So the noble person rouses the people and sets them to work, and through honest labor nourishes their character anew.",
        "gloss": "Mend the inherited decay",
        "lineTexts": [
            "Repairing what the father has spoiled, the son redeems the elder's name; where there is such an heir, no blame remains. Danger lingers, yet the end is good fortune.",
            "Repairing what the mother has spoiled, proceed with gentleness and do not force the correction. Too rigid a hand here cannot be made right.",
            "Repairing what the father has spoiled, there is some small regret for acting with too much vigor, yet no grave fault follows.",
            "To tolerate and excuse what the father has spoiled is to let the rot deepen. Persist on this path and you will meet only humiliation.",
            "Repairing what the father has spoiled, you earn praise and are met with honor. The work, taken up rightly, brings recognition.",
            "He does not serve king or prince but sets his own loftier affairs above them. Withdrawing from the common work, he tends a higher purpose worthy of esteem."
        ]
    },
    {
        "number": 19,
        "name": {
            "chinese": "臨",
            "pinyin": "lín",
            "english": "Approach"
        },
        "bits": [
            1,
            1,
            0,
            0,
            0,
            0
        ],
        "upper": "kun",
        "lower": "dui",
        "judgment": "Approach brings sublime success, and it is favorable to remain steadfast and true. Yet a warning is woven into the promise: when the eighth month comes, misfortune will arrive. What rises now must remember that its season is not endless.",
        "image": "The Earth rests above the Lake, the high ground bending close over the depths it overlooks. Thus the noble person is inexhaustible in the will to teach and tireless in tolerance, sheltering and sustaining the people without limit.",
        "gloss": "The strong draws near with care",
        "lineTexts": [
            "Approaching together in shared purpose, the way is open. Hold firmly to what is right, and good fortune follows.",
            "Approaching together in shared purpose brings good fortune, and all turns out favorably. Move forward without misgiving.",
            "A comfortable approach that flatters and presumes serves nothing well. Yet if one grieves over the fault and amends it, the blame will not endure.",
            "Drawing near with full and faultless devotion, the approach reaches its proper place. There is no error in giving oneself completely.",
            "An approach of wisdom, fitting for a great ruler, governs through others without grasping. This is the way of good fortune.",
            "An approach of generous greatness, large-hearted and unhurried, brings good fortune and stands free of blame."
        ]
    },
    {
        "number": 20,
        "name": {
            "chinese": "觀",
            "pinyin": "guān",
            "english": "Contemplation"
        },
        "bits": [
            0,
            0,
            0,
            0,
            1,
            1
        ],
        "upper": "xun",
        "lower": "kun",
        "judgment": "Contemplation is like the ablution that precedes the offering, when the hands are washed but the sacrifice not yet made. In that pause, sincerity gathers and shines forth, and those who look upon it are moved to reverence. Be the example others can behold, and your bearing alone becomes a teaching.",
        "image": "The Wind moves across the face of the Earth, passing over all things and touching each in turn. So the kings of old surveyed the four regions, observed the people, and set forth their teachings according to what they saw.",
        "gloss": "To behold and be beheld",
        "lineTexts": [
            "A boyish, shallow contemplation sees only the surface. For the common person no harm comes of it, but for one of higher station it brings regret.",
            "A peering contemplation through the crack of the door sees little of the whole. Such a narrow view befits one within the home, but for a person of breadth it is cause for shame.",
            "Contemplating the course of one's own life, observing whether to advance or withdraw, one learns to read the moment and choose without error.",
            "Contemplating the light and bounty of the realm, one is fit to be the guest of the king, serving where influence and honor meet.",
            "Contemplating one's own life and conduct, the noble person looks inward upon the effect cast upon others. Judged by that mirror, there is no blame.",
            "Contemplating the life of all beneath heaven, observing the whole rather than the self alone, the noble person stands free of fault."
        ]
    },
    {
        "number": 21,
        "name": {
            "chinese": "噬嗑",
            "pinyin": "shì kè",
            "english": "Biting Through"
        },
        "bits": [
            1,
            0,
            0,
            1,
            0,
            1
        ],
        "upper": "li",
        "lower": "zhen",
        "judgment": "Biting through brings success, for the obstacle lodged between the jaws must be cracked before union can be restored. It is favorable to administer justice and let the law take its course. Where something hard stands in the way, decisive force, fairly applied, is the only remedy.",
        "image": "Thunder and Lightning meet, the one striking and the other illuminating, and together they make the law plain to all. Thus the kings of old made firm their penalties and clarified their statutes, joining clear sight to forceful action.",
        "gloss": "Crack through the obstruction",
        "lineTexts": [
            "His feet are locked in the stocks so that the toes are hidden, and a small fault is checked before it grows. There is no blame in being corrected early.",
            "Biting through tender flesh, one sinks in so deep the nose disappears. The fault punished is plain and the rebuke is sharp, yet no blame attaches to it.",
            "Biting on dried and tainted meat, one meets something foul and is poisoned by it. There is small humiliation, but no real fault, for the task itself was hard.",
            "Biting on dried gristle wrapped about the bone, one finds metal arrows within. It is favorable to be mindful of hardship and to stay upright; persevere and good fortune comes.",
            "Biting on dried lean meat, one finds yellow gold within. Hold to your purpose with awareness of danger, and no blame will follow.",
            "His neck is clamped in the cangue so that the ears are hidden, for he would not heed correction. This brings misfortune to one deaf to warning."
        ]
    },
    {
        "number": 22,
        "name": {
            "chinese": "賁",
            "pinyin": "bì",
            "english": "Grace"
        },
        "bits": [
            1,
            0,
            1,
            0,
            0,
            1
        ],
        "upper": "gen",
        "lower": "li",
        "judgment": "Grace brings success, but in lesser things it is favorable to undertake something. Adornment lends beauty and ease to small affairs, yet ornament alone cannot decide what is great. Let form serve substance, and the form will be pleasing.",
        "image": "Fire glows at the foot of the Mountain, casting its light upward and lending the heights a passing splendor. So the noble person brings clarity and order to the affairs of the day, but does not presume to decide weighty matters of justice by appearance alone.",
        "gloss": "Beauty that adorns the true",
        "lineTexts": [
            "He lends grace to his toes, leaves the carriage behind, and goes on foot. Refusing an unworthy ease, he walks his own honest road.",
            "He lends grace to the beard upon his chin. The adornment must follow what it adorns and rise only with the one it serves.",
            "Graced and moistened, glistening as if anointed, all seems fair and flowing. Persevering steadfastly in this brings lasting good fortune.",
            "Graced or plain, the white horse comes as if on wings. He is no robber but a suitor; the simple truth, once seen, ends all suspicion.",
            "Grace upon the hills and in the garden, where the roll of silk offered is meager and slight. There is humiliation in the smallness of the gift, yet in the end good fortune comes.",
            "Simple white grace, ornament pared back to plainness, leaves no blame. When adornment returns to purity, the form has reached its truth."
        ]
    },
    {
        "number": 23,
        "name": {
            "chinese": "剝",
            "pinyin": "bō",
            "english": "Splitting Apart"
        },
        "bits": [
            0,
            0,
            0,
            0,
            0,
            1
        ],
        "upper": "gen",
        "lower": "kun",
        "judgment": "Splitting apart shows the dark forces rising while the light is worn away from below. In such a time it is not favorable to go anywhere or undertake anything. The wise yield to the season, holding still until the wearing-away has run its course.",
        "image": "The Mountain rests upon the Earth, and what should stand high is being undermined from beneath. Thus those above can secure their place only by being generous to those below, strengthening the foundation that bears them up.",
        "gloss": "Decay creeps up from below",
        "lineTexts": [
            "The leg of the bed is split away, and the steadfast are destroyed at the very base. Misfortune begins where it can least be seen.",
            "The frame of the bed is split away, and the support that should hold firm gives way. To stand alone now, without allies, brings misfortune.",
            "He splits with the others around him, breaking from the decay that surrounds him. In choosing the right against the tide, there is no blame.",
            "The bed is split away up to the skin, and the danger has reached the body itself. Misfortune presses close, and there is no longer any shelter.",
            "A string of fishes, and the favor of the palace ladies follows in order. Led gracefully toward the light, all turns to advantage and nothing is without benefit.",
            "A great fruit remains uneaten, holding the seed of all that is to come. The noble person is carried as on a carriage, while the house of the small is split apart."
        ]
    },
    {
        "number": 24,
        "name": {
            "chinese": "復",
            "pinyin": "fù",
            "english": "Return"
        },
        "bits": [
            1,
            0,
            0,
            0,
            0,
            0
        ],
        "upper": "kun",
        "lower": "zhen",
        "judgment": "Return brings success, for the light, once spent, comes back without strain or harm. Friends arrive and there is no fault; the way turns and comes again, completing its round in seven days. It is favorable to have somewhere to go, for the movement of life renews itself.",
        "image": "Thunder stirs again within the depths of the Earth, the first pulse of life returning at the dead of winter. Thus the kings of old closed the passes at the solstice, halting the merchants and travelers so the tender beginning might gather strength undisturbed.",
        "gloss": "The turning point of light",
        "lineTexts": [
            "Returning from no great distance, one turns back before going far astray. There is no need for remorse, and the outcome is sublime good fortune.",
            "A quiet and willing return, content to come back in good company, brings good fortune. To follow what is good is no weakness.",
            "Returning again and again, hesitant and repeated, betrays an unsettled heart. There is danger in such wavering, yet no lasting blame.",
            "Walking in the midst of others, one turns back alone toward the right path. Though set apart from the crowd, the solitary return is true.",
            "A noble-hearted return, weighed in honest self-reflection, leaves no cause for regret. To search one's own conduct is to come home well.",
            "A deluded return, missing the moment to turn back, brings misfortune and lasting harm. Armies set marching now will end in great defeat, and the ruler will suffer for years to come."
        ]
    },
    {
        "number": 25,
        "name": {
            "chinese": "無妄",
            "pinyin": "wú wàng",
            "english": "Innocence"
        },
        "bits": [
            1,
            0,
            0,
            1,
            1,
            1
        ],
        "upper": "qian",
        "lower": "zhen",
        "judgment": "When the heart is true and free of calculation, there is supreme success, and constancy brings reward. But should the will turn aside from what is right, misfortune follows, and nothing is gained by setting out. Act from your nature, not from scheming, and heaven itself moves with you.",
        "image": "Beneath heaven the thunder rolls, and all things stir into their own innocent being. Thus the noble person nourishes each creature in its proper season, rich in virtue and faithful to the order of nature, asking of life only what life freely offers.",
        "gloss": "Acting from the unspoiled heart",
        "lineTexts": [
            "Innocence in its first movement carries you forward; advance, for the heart that is yet uncalculating will find its way.",
            "Do not count the harvest while you plow, nor measure the field while you clear it; work without thought of reward, and it is well to go on.",
            "Undeserved misfortune may strike: the ox tethered by the road is taken by a passing stranger, and the villager bears the loss for no fault of his own.",
            "Hold fast to what is yours by right and need ask nothing of anyone; remaining steadfast, you cannot truly err.",
            "An affliction that comes through no doing of your own needs no remedy; let it pass untreated, and it will heal of itself.",
            "When innocence would force its way forward, action brings harm; here even the blameless must rest, for the time itself forbids the step."
        ]
    },
    {
        "number": 26,
        "name": {
            "chinese": "大畜",
            "pinyin": "dà chù",
            "english": "The Taming Power of the Great"
        },
        "bits": [
            1,
            1,
            1,
            0,
            0,
            1
        ],
        "upper": "gen",
        "lower": "qian",
        "judgment": "Great accumulating: it is favorable to be firm and enduring. To eat one's bread away from home brings fortune, for the gathered strength is meant for the wider world. It furthers one to cross the great water.",
        "image": "Heaven dwells within the mountain, vast power held in stillness and treasured up. Thus the noble person studies the words and deeds of the ancients, storing them within, until inner riches grow great enough to act upon.",
        "gloss": "Strength held still and treasured",
        "lineTexts": [
            "Danger waits ahead, and the wise course is to halt; do not press on, but accept the restraint laid upon you.",
            "The axle is loosed from the cart of its own accord; the strong force pauses, and there is no blame in standing still.",
            "Now horses race side by side and the way opens; yet remain mindful and practice daily guarding, holding firm, and it is good to have somewhere to go.",
            "A guard board set on the young bull's horns, before the horns have hardened, restrains harm at its source; great is the good fortune.",
            "The tusks of a gelded boar: the dangerous power is curbed at the root and grows tame; here is good fortune.",
            "One attains the open road of heaven, where the gathered virtue finds its release at last; success flows unhindered."
        ]
    },
    {
        "number": 27,
        "name": {
            "chinese": "頤",
            "pinyin": "yí",
            "english": "The Corners of the Mouth"
        },
        "bits": [
            1,
            0,
            0,
            0,
            0,
            1
        ],
        "upper": "gen",
        "lower": "zhen",
        "judgment": "Nourishment: to remain steadfast brings fortune. Observe what a person gives to be nourished, and how they seek to fill their own mouth, and you will know their worth. Be mindful of what you take in, of body and of spirit alike.",
        "image": "At the foot of the mountain the thunder stirs, the image of nourishment given and received. Thus the noble person is careful in speech that goes out from the mouth and temperate in the food that goes in, watching over the source of words and the source of life.",
        "gloss": "What we take in shapes us",
        "lineTexts": [
            "You set aside your own sustaining power to gaze with envy at another's full cheeks; this brings misfortune.",
            "To seek nourishment from those below, or to turn to the heights for what should come from your peers, departs from the proper way; to set out thus brings misfortune.",
            "Nourishment sought against the natural order brings no good though you hold to it; for ten years do not act, for nothing here is of use.",
            "To look downward for nourishment brings good fortune; like a tiger watching with steady, hungry gaze, the desire is keen yet without blame.",
            "Turning from the ordinary path, you remain at rest and hold firm, and this brings fortune; but it is not yet the time to cross the great water.",
            "Here is the source from which all nourishment flows; aware of the danger and the weight of it, there is good fortune, and it furthers one to cross the great water."
        ]
    },
    {
        "number": 28,
        "name": {
            "chinese": "大過",
            "pinyin": "dà guò",
            "english": "Preponderance of the Great"
        },
        "bits": [
            0,
            1,
            1,
            1,
            1,
            0
        ],
        "upper": "dui",
        "lower": "xun",
        "judgment": "The great exceeds its measure: the ridgepole bends beneath its load, strong at the center but weak at either end. Yet it furthers one to have a place to go, and success may still be reached. Extraordinary times call for extraordinary, but well-considered, action.",
        "image": "The lake rises above the trees and drowns them, the image of excess pressing past all bounds. Thus the noble person stands alone without fear and, if need be, withdraws from the world without sorrow, steadfast in solitude when the times are out of joint.",
        "gloss": "The ridgepole strained near breaking",
        "lineTexts": [
            "You spread white rushes beneath the offering, taking the utmost care with what is set down; such caution at the start is without blame.",
            "A withered poplar puts forth fresh shoots, an old man takes a young wife: against all expectation, life renews itself, and all is favorable.",
            "The ridgepole sags to breaking under a weight it cannot bear; stubborn and unaided, this brings misfortune.",
            "The ridgepole is braced and rises firm, and there is good fortune; but if some other purpose is harbored within, it brings humiliation.",
            "A withered poplar puts forth blossoms, an old woman takes a young husband: no fault, perhaps, yet no lasting praise, for the bloom cannot endure.",
            "One wades in until the water closes over the head; misfortune, yet there is no blame, for the loss was met in service of what was right."
        ]
    },
    {
        "number": 29,
        "name": {
            "chinese": "坎",
            "pinyin": "kǎn",
            "english": "The Abysmal Water"
        },
        "bits": [
            0,
            1,
            0,
            0,
            1,
            0
        ],
        "upper": "kan",
        "lower": "kan",
        "judgment": "The abyss repeated, danger upon danger. If you are sincere and let the heart flow through unbroken, there is success in the very midst of peril, and whatever you undertake will be honored. Move as water moves, faithful to its course, and the way through will appear.",
        "image": "Water flows on and on, ever arriving, filling each hollow before it passes onward; this is the image of doubled danger. Thus the noble person holds steadfast to virtue through every depth and teaches by repeating the work, so that what is learned may take and hold.",
        "gloss": "Flowing true through the depths",
        "lineTexts": [
            "Trapped in the abyss within the abyss, fallen into the deepest pit; here is misfortune, for one has lost the way entirely.",
            "Danger presses close on every side; seek only the smallest gain, take one sure step, and do not yet attempt the great escape.",
            "Whichever way you turn, abyss meets abyss; danger before and danger behind, so pause and do not act, lest you sink deeper still.",
            "A jug of wine, a bowl of rice, plain vessels passed through the window in simple sincerity; in the end there is no blame.",
            "The abyss is not yet filled to overflowing; level it only to the brim and go no further, and there will be no fault.",
            "Bound with cords and ropes and set among thorns, shut away for three long years without finding the path; misfortune."
        ]
    },
    {
        "number": 30,
        "name": {
            "chinese": "離",
            "pinyin": "lí",
            "english": "The Clinging Fire"
        },
        "bits": [
            1,
            0,
            1,
            1,
            0,
            1
        ],
        "upper": "li",
        "lower": "li",
        "judgment": "That which clings finds its nature by holding to what is right; remaining devoted brings success. To care for the cow brings good fortune, for gentle, dependable strength sustains the flame. Let your radiance rest upon what is true, and it will endure.",
        "image": "A double brightness, fire kindled upon fire, the great light renewed without end. Thus the great person, taking this for a model, lets an illumining clarity shine forth to the four quarters of the world.",
        "gloss": "Light that clings to what is true",
        "lineTexts": [
            "The footsteps fall crisscross and confused at the day's beginning; move with reverence and care, and you remain without blame.",
            "A yellow radiance, the light of the balanced center: here is supreme good fortune.",
            "In the glow of the setting sun, one either beats the pot and sings or laments aloud the coming of old age; misfortune lies in clinging to what must fade.",
            "Its coming is abrupt, flaring up, then dying down, cast aside as swiftly as it blazed; such untempered fire cannot last.",
            "Tears flow in floods and grief wells up in sighs; yet through this sorrow the heart is purified, and good fortune follows.",
            "The king sends forth his armies, and there is something worthy in the campaign; he strikes the leaders, spares those merely swept along, and remains without blame."
        ]
    },
    {
        "number": 31,
        "name": {
            "chinese": "咸",
            "pinyin": "xián",
            "english": "Influence"
        },
        "bits": [
            0,
            0,
            1,
            1,
            1,
            0
        ],
        "upper": "dui",
        "lower": "gen",
        "judgment": "Mutual influence brings success, and constancy is rewarded. To take a maiden in marriage brings good fortune, for the meeting is willing and the attraction is true. When stillness below opens to joy above, the hearts of all things are drawn together.",
        "image": "Upon the mountain rests the lake, the firm receiving the yielding, the high made low to welcome it; this is the image of influence. Thus the noble person keeps the mind open and receptive, that the feelings of others may freely enter and take root.",
        "gloss": "Hearts drawn by open feeling",
        "lineTexts": [
            "The influence stirs only in the big toe; the impulse is faint and stays within, not yet enough to set anything in motion.",
            "The influence reaches the calves of the legs; to rush forward now brings misfortune, but to abide quietly brings good fortune.",
            "The influence moves the thighs, which only follow where the body leads; to set out clinging to others in this way brings humiliation.",
            "Persevering brings fortune and regret dissolves; but if the heart wavers and thoughts come and go in restless agitation, only a few friends will follow your wandering aim.",
            "The influence reaches the back of the neck, stiff and beyond the heart's reach; the feeling is shallow, yet here at least there is no cause for regret.",
            "The influence shows itself in the jaws, the cheeks, the tongue, in mere talk and persuasion; words alone, with no deeper movement behind them."
        ]
    },
    {
        "number": 32,
        "name": {
            "chinese": "恆",
            "pinyin": "héng",
            "english": "Duration"
        },
        "bits": [
            0,
            1,
            1,
            1,
            0,
            0
        ],
        "upper": "zhen",
        "lower": "xun",
        "judgment": "Duration brings success, and there is no blame in it; constancy is rewarded. It furthers one to have a place to go, for what endures is not stillness but steady movement that renews itself. Hold to your course, and it will carry you far.",
        "image": "Thunder above and wind below, each rousing and sustaining the other in lasting union; this is the image of duration. Thus the noble person stands firm and does not turn aside from the direction once chosen, enduring through every change.",
        "gloss": "Steadfast endurance through change",
        "lineTexts": [
            "Seeking deep endurance too soon and too hard at the very outset, you press for permanence before its time; persisting thus brings misfortune, and nothing is gained.",
            "Regret vanishes here, for you hold to the lasting center and your strength is matched to the moment.",
            "If you do not give your virtue a steady home, disgrace will surely find you; holding to such inconstancy only brings shame.",
            "There is no game in the field, for you have hunted where nothing is to be found; constancy spent on the wrong place yields nothing.",
            "Holding firmly to a single course brings fortune to the wife, who follows steadfastly to the end, but misfortune to the husband, who must judge each matter anew.",
            "Endurance kept in restless agitation, forever stirred and never settled, brings misfortune; what cannot rest cannot truly last."
        ]
    },
    {
        "number": 33,
        "name": {
            "chinese": "遯",
            "pinyin": "dùn",
            "english": "Retreat"
        },
        "bits": [
            0,
            0,
            1,
            1,
            1,
            1
        ],
        "upper": "qian",
        "lower": "gen",
        "judgment": "Retreat brings success when it is timely. The dark is rising from below, and the strong yield ground not in defeat but in measured withdrawal. To step back at the right moment preserves strength; even in small things, perseverance is rewarded.",
        "image": "Heaven over Mountain: the sky draws back as the peak strains upward, distant and unreachable. So the noble person keeps the petty at a distance, not through anger but through dignified reserve, holding firm without rancor.",
        "gloss": "Yielding ground to preserve strength",
        "lineTexts": [
            "At the tail of the retreat, lagging behind brings danger. Here one should not press forward but stay still and undertake nothing.",
            "He is bound to his purpose with the hide of a yellow ox, and none can loosen the hold. Such firm resolve cannot be torn away.",
            "A retreat entangled by attachments brings unrest and weariness. To keep servants and dependents close may bring small fortune, but it is no work for great affairs.",
            "The superior person retreats willingly and finds good fortune; the lesser person, clinging, cannot. To let go cleanly is the mark of strength.",
            "A friendly retreat, correct and well-timed, brings good fortune. He withdraws while relations are still warm, leaving nothing soured behind.",
            "A cheerful and unhampered retreat, free of every doubt. Where the heart is light and the way is clear, all furthers."
        ]
    },
    {
        "number": 34,
        "name": {
            "chinese": "大壯",
            "pinyin": "dà zhuàng",
            "english": "The Power of the Great"
        },
        "bits": [
            1,
            1,
            1,
            1,
            0,
            0
        ],
        "upper": "zhen",
        "lower": "qian",
        "judgment": "The Power of the Great favors perseverance. Strength has risen to its fullness, but greatness lies not in force alone; it must remain wedded to what is right. Power that serves justice endures, while power for its own sake undoes itself.",
        "image": "Thunder over Heaven: the rolling power above the firmament, vast and resounding. So the noble person does not tread any path that is not in keeping with order, refusing to step where propriety forbids.",
        "gloss": "Great strength held within right limits",
        "lineTexts": [
            "Power shows itself in the toes, rushing eagerly ahead. To advance now would bring misfortune; the impulse outruns the means.",
            "Perseverance brings good fortune. The strong line holds its center, neither forcing forward nor falling back, and so it keeps its measure.",
            "The lesser person trusts in raw power; the superior person does not. A ram butts against a hedge and tangles its horns, undone by its own headlong force.",
            "Perseverance brings good fortune, and regret fades away. The hedge gives way and the horns come free; great strength moves like the axle of a heavy cart, surging without strain.",
            "He loses the ram with ease, with no remorse. When gentleness replaces stubborn force, what was held too tightly is released without harm.",
            "The ram butts the hedge and can move neither forward nor back. To see the difficulty clearly and bear with it brings, in the end, good fortune."
        ]
    },
    {
        "number": 35,
        "name": {
            "chinese": "晉",
            "pinyin": "jìn",
            "english": "Progress"
        },
        "bits": [
            0,
            0,
            0,
            1,
            0,
            1
        ],
        "upper": "li",
        "lower": "kun",
        "judgment": "Progress: like a powerful prince honored with horses in abundance, received in audience three times in a single day. The light rises clear above the earth, and one who serves faithfully is recognized and advanced. Easy and rapid ascent follows when devotion meets a receptive sun.",
        "image": "Fire over Earth: the sun climbs above the horizon, and its light grows brighter as it rises. So the noble person brightens his own bright virtue, polishing the clarity within until it shines of itself.",
        "gloss": "The rising sun, clarity advancing",
        "lineTexts": [
            "Progressing, yet turned back. To remain steadfast brings good fortune; if trust is not yet granted, stay calm and unhurried, and no blame attaches.",
            "Progressing, yet in sorrow. Perseverance brings good fortune, and one receives great blessing from the maternal source above.",
            "All are in accord, and remorse disappears. When many move forward together in trust, the way opens without hindrance.",
            "Progress like a hamster, grasping and furtive. To persist on such a path, however well it seems to go, courts danger.",
            "Remorse vanishes; care nothing for loss or gain. To go forward openly brings good fortune, and nothing fails to further.",
            "Progressing with the horns, used only to chastise one's own city. To turn such force inward is dangerous yet brings good fortune and no blame; persistence alone leaves a trace of regret."
        ]
    },
    {
        "number": 36,
        "name": {
            "chinese": "明夷",
            "pinyin": "míng yí",
            "english": "Darkening of the Light"
        },
        "bits": [
            1,
            0,
            1,
            0,
            0,
            0
        ],
        "upper": "kun",
        "lower": "li",
        "judgment": "In the Darkening of the Light, it furthers one to persevere through hardship. The bright is wounded and driven beneath the earth, and a wise course is to veil one's brilliance and hold inwardly fast. To keep one's light hidden in a dark time is itself the way through.",
        "image": "Earth over Fire: the brightness has sunk into the heart of the ground, its radiance covered over. So the noble person, governing the multitudes, veils his own clarity and yet remains illumined within.",
        "gloss": "Hiding the inner light in darkness",
        "lineTexts": [
            "The darkening of the light in flight: he lowers his wings. The noble person, traveling, goes three days without food; where he comes, the host has words against him, yet he presses on with a purpose.",
            "The darkening of the light wounds him in the left thigh. He saves himself by the strength of a swift horse, and good fortune follows the rescue.",
            "The darkening of the light hunting in the south seizes the great chief of darkness. One must not expect to set all things right too quickly.",
            "Entering deep into the left side of the belly, he reaches the very heart of the dark, and there discerns its true nature. So he takes his leave through the gate and the courtyard.",
            "The darkening of the light as it was with Prince Chi. Persistence furthers; he conceals his light yet keeps his will unbroken.",
            "Not light but darkness. First he climbed to the heavens, then plunged into the depths of the earth, and the great brightness fell utterly away."
        ]
    },
    {
        "number": 37,
        "name": {
            "chinese": "家人",
            "pinyin": "jiā rén",
            "english": "The Family"
        },
        "bits": [
            1,
            0,
            1,
            0,
            1,
            1
        ],
        "upper": "xun",
        "lower": "li",
        "judgment": "For the Family, the perseverance of the woman furthers. When each member holds true to their proper place, the household stands firm, and from a well-ordered home the right order of the world flows outward. Inner devotion, faithfully kept, is the root of all that endures.",
        "image": "Wind over Fire: the flame gives birth to the wind, and warmth spreads outward from the hearth. So the noble person makes his words substantial and his conduct enduring, knowing that influence begins at home.",
        "gloss": "Order within the household",
        "lineTexts": [
            "Firm seclusion within the family; remorse disappears. To set clear bounds at the outset, before bad habits take root, keeps the household whole.",
            "She should not follow her own whims, but tend to the food within the house. Quiet devotion to the proper work brings good fortune through perseverance.",
            "When tempers grow too hot in the family, regret and danger follow, yet good fortune remains. If women and children only laugh and trifle, the way is lost in the end.",
            "She is the treasure of the house, the source of its wealth. Great good fortune comes from one who enriches the home through steady care.",
            "As a king he draws near to his family; let there be no anxiety, for good fortune attends. Where love rules without fear, all are at peace.",
            "His work commands lasting trust and quiet dignity. In the end this brings good fortune, for sincerity carried through wins reverence."
        ]
    },
    {
        "number": 38,
        "name": {
            "chinese": "睽",
            "pinyin": "kuí",
            "english": "Opposition"
        },
        "bits": [
            1,
            1,
            0,
            1,
            0,
            1
        ],
        "upper": "li",
        "lower": "dui",
        "judgment": "In Opposition, small matters bring good fortune. When wills are divided and estrangement reigns, great undertakings cannot succeed, yet in lesser things accord may still be found. Even where natures differ, a common ground remains for those who seek it.",
        "image": "Fire over Lake: flame rises while water sinks, the two forever moving apart. So the noble person, amid all fellowship, preserves his own difference, joining with others yet remaining himself.",
        "gloss": "Estrangement that yet seeks reunion",
        "lineTexts": [
            "Remorse disappears. If you lose your horse, do not chase it; it will return of itself. When you meet evil people, guard against mistakes, and no blame remains.",
            "One meets his lord in a narrow lane. There is no blame in such a chance encounter when both incline toward reunion.",
            "One sees the wagon dragged back, the oxen halted, the man's hair and nose cut off. No good beginning, but a good end at last.",
            "Isolated through opposition, one meets a kindred spirit and joins with him in good faith. Though the situation is dangerous, no blame remains.",
            "Remorse disappears. The companion bites his way through the wrappings; if you go to him, how could it be a mistake?",
            "Isolated through opposition, one sees the companion as a pig caked with mud, a wagon full of devils. First he draws the bow, then lays it aside; he is no robber but a wooer. Going forward, he meets the rain, and good fortune comes."
        ]
    },
    {
        "number": 39,
        "name": {
            "chinese": "蹇",
            "pinyin": "jiǎn",
            "english": "Obstruction"
        },
        "bits": [
            0,
            0,
            1,
            0,
            1,
            0
        ],
        "upper": "kan",
        "lower": "gen",
        "judgment": "Obstruction: the southwest furthers, the northeast does not. It furthers one to see the great person, and perseverance brings good fortune. When the road ahead is blocked, do not force the passage; turn inward, seek wise counsel, and the way will open in time.",
        "image": "Water over Mountain: the danger of the flood meets the barrier of the peak, and the path is halted before a double difficulty. So the noble person turns his gaze upon himself and works to mold his own character.",
        "gloss": "Halted before a hard road",
        "lineTexts": [
            "Going leads into obstruction; coming brings praise. To wait and turn back now, rather than press into difficulty, earns honor.",
            "The servant of the king meets obstruction upon obstruction, yet it is not for his own sake. He does not falter, for duty, not gain, drives him on.",
            "Going leads into obstruction; therefore he turns back. Those who depend on him rejoice at his return.",
            "Going leads into obstruction; coming brings union. He waits, and gathers those who will share the difficulty with him.",
            "In the midst of the greatest obstruction, friends arrive. The hard line at the center draws helpers to its side when need is deepest.",
            "Going leads into obstruction; coming brings great good fortune. It furthers one to see the great person, for one who returns to lend his strength achieves much."
        ]
    },
    {
        "number": 40,
        "name": {
            "chinese": "解",
            "pinyin": "xiè",
            "english": "Deliverance"
        },
        "bits": [
            0,
            1,
            0,
            1,
            0,
            0
        ],
        "upper": "zhen",
        "lower": "kan",
        "judgment": "Deliverance: the southwest furthers. If there is nowhere left to go, return brings good fortune; if there is still somewhere to go, then haste brings good fortune. When the tension breaks, resolve matters quickly and then come back to rest, harboring no grievance.",
        "image": "Thunder over Water: the storm bursts, the thunder rolls, and the tension of the air is released in cleansing rain. So the noble person pardons faults and forgives wrongs, letting the air clear and the burden fall away.",
        "gloss": "The storm breaks, tension released",
        "lineTexts": [
            "Without blame. At the moment of release, one rests in stillness; nothing more need be said or done.",
            "He kills three foxes in the field and receives a yellow arrow. Perseverance brings good fortune to one who clears away cunning deceit and holds the middle course.",
            "A man carries a burden on his back yet rides in a carriage, tempting robbers to draw near. Such unfitting display, however justified, brings humiliation.",
            "Free yourself from the toe you cling to; then the true companion comes, and in him you may trust. Letting go of low attachments draws worthy friends near.",
            "If the noble person frees himself, good fortune follows, and even the petty ones are won over. When the heart is truly released, the small-minded fall away of themselves.",
            "The prince shoots at a hawk upon a high wall and brings it down. Nothing that does not further; the obstacle is removed at a single, well-prepared stroke."
        ]
    },
    {
        "number": 41,
        "name": {
            "chinese": "損",
            "pinyin": "sǔn",
            "english": "Decrease"
        },
        "bits": [
            1,
            1,
            0,
            0,
            0,
            1
        ],
        "upper": "gen",
        "lower": "dui",
        "judgment": "What is taken from below to enrich above can yet be blessed, if the diminishing is done in sincerity. A simple offering, given with an honest heart, outweighs a lavish one given without it. When less is asked of the self, the way ahead opens and there is gain in every undertaking.",
        "image": "The Mountain stands above the Lake, its weight drawing down the water held below. Thus the noble person curbs anger and restrains the appetites, lessening within what swells too freely. To decrease the lower in service of the higher is to refine the whole.",
        "gloss": "Less, offered in sincerity",
        "lineTexts": [
            "Setting your own affairs aside to hasten and help another is no fault, yet weigh first how much you may rightly give.",
            "Holding firm is favorable, and to set forth would bring misfortune; one increases another best by losing nothing of oneself.",
            "When three walk together, one departs; when one walks alone, a companion is found. The proper number returns of itself.",
            "By lessening the affliction one carries, others are moved to come quickly with their gladness; no blame.",
            "Such increase comes that none can turn it aside, as if ten tortoise-shells confirmed the favor; supreme good fortune.",
            "To increase others without taking from them is the highest gain; one finds servants everywhere, and the household is no longer a barrier."
        ]
    },
    {
        "number": 42,
        "name": {
            "chinese": "益",
            "pinyin": "yì",
            "english": "Increase"
        },
        "bits": [
            1,
            0,
            0,
            0,
            1,
            1
        ],
        "upper": "xun",
        "lower": "zhen",
        "judgment": "It furthers one to undertake something, and to cross the great water brings reward. When those above give freely to those below, the people rejoice without measure and the work prospers. This is the season for movement and for bold and generous endeavor.",
        "image": "Wind drives above and Thunder rouses below, each strengthening the other so that their force is multiplied. Thus the noble person, seeing good in another, hastens to imitate it, and finding fault in himself, sets at once to mending it. So does one increase without ceasing.",
        "gloss": "Generous abundance set in motion",
        "lineTexts": [
            "Now is the time to attempt great deeds; supreme fortune follows, and there is no blame, for the strength flows from above.",
            "Such increase arrives that none may turn it back, as ten tortoise-shells confirm; constancy brings fortune, and even the offering to the high is blessed.",
            "Increase reaches one through unfortunate events, yet there is no blame if you remain sincere and walk the middle path, reporting plainly to the prince.",
            "Walking the middle way, your counsel is heeded by the prince; you may lean upon him in moving the people and shifting the seat of rule.",
            "If a sincere and kindly heart guides you, ask nothing in return; supreme fortune, for your kindness is itself acknowledged as your worth.",
            "He brings increase to no one, and some will even strike at him; his heart is not steadfast, and misfortune comes."
        ]
    },
    {
        "number": 43,
        "name": {
            "chinese": "夬",
            "pinyin": "guài",
            "english": "Breakthrough"
        },
        "bits": [
            1,
            1,
            1,
            1,
            1,
            0
        ],
        "upper": "dui",
        "lower": "qian",
        "judgment": "The matter must be carried resolutely to the court, named openly and in truth. Yet there is danger; rouse only your own city, and do not reach hastily for arms. It furthers one to have a goal toward which to move, but the resolve must be tempered with caution.",
        "image": "The Lake has risen up to Heaven and presses against it, and its waters must break and fall. Thus the noble person dispenses wealth to those below and shuns the hoarding that lifts one too high. What gathers beyond its measure must be released before it bursts.",
        "gloss": "Resolute release of what must fall",
        "lineTexts": [
            "Strong in the advancing toes, you go forward; but if you cannot prevail, the venture turns to blame.",
            "Vigilant and crying alarm through the night, you need not fear, for you are armed against the coming danger.",
            "Strength shows in the cheekbones and brings misfortune; the noble one walks on alone through the rain, soiled and resented, yet in the end without blame.",
            "There is no skin on the thighs, and the going is halting; led like a sheep, regret would vanish, but the warning is not believed.",
            "The weeds must be hoed with firm decision; walk the middle path and there is no blame.",
            "No cry of warning is raised, and in the end comes misfortune; the last small remnant of evil is not to be neglected."
        ]
    },
    {
        "number": 44,
        "name": {
            "chinese": "姤",
            "pinyin": "gòu",
            "english": "Coming to Meet"
        },
        "bits": [
            0,
            1,
            1,
            1,
            1,
            1
        ],
        "upper": "qian",
        "lower": "xun",
        "judgment": "A single yielding force has returned and pushes upward among the strong; she is bold, and one should not take such a maiden to wife. What seems a small and welcome encounter can spread until it overruns all; do not bind yourself to what cannot be lastingly held.",
        "image": "Heaven stands above the Wind, which moves beneath it and carries the prince's word to every corner of the land. Thus the sovereign disperses his commands abroad and makes them known to the four directions. What meets all things must speak to all things.",
        "gloss": "The small returns, unbidden, to meet",
        "lineTexts": [
            "It must be checked with a bronze brake at the outset; persevere and there is fortune, but let it run free and a lean pig will thrash about wildly.",
            "There is a fish in the tank; no blame, yet it does not serve to offer it to guests.",
            "There is no skin on the thighs, and the going is halting; remain mindful of the danger and no grave fault will follow.",
            "There is no fish in the tank; from this emptiness will come misfortune, for the bond with those below has been let slip.",
            "A melon is sheltered beneath leaves of the willow; hidden lines of worth are kept, and what is fated will descend from heaven of itself.",
            "He comes to meet with his horns, held stiff and aloof; there is humiliation, though no real blame remains."
        ]
    },
    {
        "number": 45,
        "name": {
            "chinese": "萃",
            "pinyin": "cuì",
            "english": "Gathering Together"
        },
        "bits": [
            0,
            0,
            0,
            1,
            1,
            0
        ],
        "upper": "dui",
        "lower": "kun",
        "judgment": "When the gathering succeeds, the king draws near to his temple, and it furthers one to see the great person. Bring a great offering, for great is the good fortune in such union; it is well to have a purpose and to move toward it. Where many come together, there must be one to whom they gather.",
        "image": "The Lake rests upon the Earth and gathers its waters into one shining body. Thus the noble person keeps his weapons in good repair, ready against the unforeseen, for where crowds collect, both harmony and discord may arise. Guard the gathering before trouble can stir within it.",
        "gloss": "Many drawn to a single center",
        "lineTexts": [
            "Your sincerity wavers and the gathering falls into confusion; cry out, and one grasp of the hand turns the lament to laughter. Go forward without fear; no blame.",
            "Let yourself be drawn in, and good fortune follows without blame; a small sincere offering, simply made, is enough.",
            "Gathering amid sighs, with nothing favorable in sight; go forward anyway, for there is no blame, only a little humiliation.",
            "Great good fortune, and with it no blame, when one gathers others not for oneself but for the common good.",
            "If you hold a high place in the gathering, there is no blame; yet where trust is not yet won, only a great and lasting constancy makes regret dissolve.",
            "Lamenting and sighing, with streaming tears; no blame, for those who grieve to be left out of the gathering at last find their way in."
        ]
    },
    {
        "number": 46,
        "name": {
            "chinese": "升",
            "pinyin": "shēng",
            "english": "Pushing Upward"
        },
        "bits": [
            0,
            1,
            1,
            0,
            0,
            0
        ],
        "upper": "kun",
        "lower": "xun",
        "judgment": "Pushing upward brings supreme success; one should seek out the great person and have no anxiety. To set forth toward the south is favorable, and the ascent is rewarded. Rise gently and steadily, as a thing that grows, and the way will yield.",
        "image": "Within the Earth, Wood grows and rises, lifting itself slowly toward the light. Thus the noble person, with devotion to what is good, gathers small things and so heaps up the great and high. Greatness is reached not by leaping but by accumulation.",
        "gloss": "Steady rising, as a tree grows",
        "lineTexts": [
            "Rising in trust and welcomed upward; great good fortune, for the ascent begins on willing ground.",
            "If sincerity is yours, even a small and simple offering is accepted; no blame.",
            "You push upward into an empty city, finding no resistance before you.",
            "The king makes his offering upon the sacred mountain; good fortune and no blame, for the ascent is consecrated.",
            "Perseverance brings good fortune as you push upward step by step upon the stairs.",
            "Pushing upward blindly in the dark; it furthers one only in unceasing, watchful constancy, lest the rising lose its way."
        ]
    },
    {
        "number": 47,
        "name": {
            "chinese": "困",
            "pinyin": "kùn",
            "english": "Oppression"
        },
        "bits": [
            0,
            1,
            0,
            1,
            1,
            0
        ],
        "upper": "dui",
        "lower": "kan",
        "judgment": "Exhaustion can yet lead to success, and for the firm and great person there is good fortune and no blame. But in such a time words are not believed; one who speaks much is not heeded. Let strength of spirit, not protest, carry you through the strait.",
        "image": "The Lake stands above the Water, yet the water has drained away below and left it dry and barren. Thus the noble person stakes his life on following his will, undismayed though fortune fail and the springs run out. When all is taken, the inner resolve remains.",
        "gloss": "Strength held fast in adversity",
        "lineTexts": [
            "Sitting oppressed beneath a bare and withered tree, one strays into a gloomy valley and for three years sees no one.",
            "Oppressed amid food and wine, yet the scarlet sashes of office are coming; it furthers one to make an offering, and to set forth would bring misfortune, though no blame.",
            "Pressed against stones, clutching at thorns; he enters his house and does not find his wife. Misfortune.",
            "He comes very slowly, oppressed in a carriage of gold; there is humiliation, yet the matter reaches its end.",
            "Nose and feet cut off, oppressed by the man in the crimson sash; joy comes slowly, and it furthers one to make the quiet offering.",
            "Oppressed by creeping vines, swaying upon an unsteady height; if he says, 'movement brings remorse,' and repents, then to go forward brings good fortune."
        ]
    },
    {
        "number": 48,
        "name": {
            "chinese": "井",
            "pinyin": "jǐng",
            "english": "The Well"
        },
        "bits": [
            0,
            1,
            1,
            0,
            1,
            0
        ],
        "upper": "kan",
        "lower": "xun",
        "judgment": "The town may be moved, but the well cannot be moved; it neither dwindles nor overflows, and all who come and go may draw from it. Yet if one nearly reaches the water and the rope falls short, or breaks the jug, there is misfortune. What nourishes all asks that the drawing be carried fully through.",
        "image": "Water lies above the Wood, which reaches down and lifts it from the depths. Thus the noble person encourages the people in their labor and urges them to help one another. The source is constant; only the drawing of it must be tended.",
        "gloss": "The unmoving source that feeds all",
        "lineTexts": [
            "The well is choked with mud and none will drink; an old well to which not even the birds come.",
            "At the wellhole one shoots only at the fish below; the jug is cracked and leaks away its water.",
            "The well is cleared, yet none drink from it; this grieves the heart, for the water could be drawn. Were the king but clear-sighted, all might share the blessing.",
            "The well is being lined with stone; there is no blame, for the work that mends the source is well spent.",
            "The well holds a clear, cold spring, and from it one may drink.",
            "The well is drawn from freely and never covered over; herein lies sincerity and supreme good fortune."
        ]
    },
    {
        "number": 49,
        "name": {
            "chinese": "革",
            "pinyin": "gé",
            "english": "Revolution"
        },
        "bits": [
            1,
            0,
            1,
            1,
            1,
            0
        ],
        "upper": "dui",
        "lower": "li",
        "judgment": "Revolution earns trust only when its hour has truly come; force it early and it breeds suspicion, but wait for the day of ripeness and the change is believed. Great success follows, and what is firm and right endures. Then every cause for regret falls away.",
        "image": "Lake stands over Fire, water and flame in irreconcilable struggle, each transforming the other. So the noble person orders the calendar and makes the seasons clear, reading the turning of time so that change arrives in step with it.",
        "gloss": "Molting the old skin",
        "lineTexts": [
            "Bound firmly in the hide of a yellow ox; nothing yet may be undertaken, for the moment to act has not arrived.",
            "When at last the proper day comes, set the changing in motion. To go forward now brings good fortune and leaves no blame behind.",
            "To press the revolution too hard invites misfortune, yet timid delay is also perilous. When talk of change has come round three times, then it carries trust and may be followed.",
            "Remorse vanishes, for now the people believe. To overturn the old order at this hour brings good fortune.",
            "The great person changes like a tiger whose fresh stripes blaze before any divination is cast; the new pattern is unmistakable and commands trust.",
            "The noble person transforms like a leopard, refining the markings of the new order; lesser people merely recast their faces. To advance further now would bring misfortune, but to abide in what is right brings good fortune."
        ]
    },
    {
        "number": 50,
        "name": {
            "chinese": "鼎",
            "pinyin": "dǐng",
            "english": "The Cauldron"
        },
        "bits": [
            0,
            1,
            1,
            1,
            0,
            1
        ],
        "upper": "li",
        "lower": "xun",
        "judgment": "The Cauldron signifies the highest good fortune and brings success. It is the vessel in which the raw is transformed into nourishment fit for the sacred and the wise. Where revolution casts down the old, the cauldron consecrates the new.",
        "image": "Fire rests above Wind, the wind feeding the flame beneath the vessel as wood feeds the cooking fire. So the noble person steadies the proper station and consolidates fate, holding firm in the place destiny has appointed.",
        "gloss": "The vessel that nourishes the holy",
        "lineTexts": [
            "The cauldron is turned over to empty its old residue. As one casts out a worn concubine for the sake of a son, what seems improper here serves to clear away the stale; no blame.",
            "The cauldron is filled with substance. My companions are jealous, yet they cannot reach me; good fortune, for the work is sound.",
            "The handle of the cauldron is altered and its carrying is blocked; the rich pheasant fat goes uneaten. But when rain falls the strain dissolves, and in the end there is good fortune.",
            "The cauldron's legs are broken and the prince's meal is spilled, the contents fouled. This is shame, and misfortune, for one was unequal to the trust laid upon him.",
            "The cauldron has yellow handles and rings of gold. It is fitting to remain firm and correct, for the means of carrying the work are now sound.",
            "The cauldron has rings of jade, lustrous and strong. Great good fortune; nothing remains that does not further the way."
        ]
    },
    {
        "number": 51,
        "name": {
            "chinese": "震",
            "pinyin": "zhèn",
            "english": "The Arousing Thunder"
        },
        "bits": [
            1,
            0,
            0,
            1,
            0,
            0
        ],
        "upper": "zhen",
        "lower": "zhen",
        "judgment": "Shock comes and brings success. When the thunder crashes the heart trembles with terror, yet afterward there is laughter and easy talk. The shock spreads alarm for a hundred miles, but the one who tends the sacred vessel does not let fall the ladle and the chalice.",
        "image": "Thunder rolls upon thunder, peal answering peal across the sky. So the noble person, in fear and trembling, sets his life in order and examines himself within.",
        "gloss": "The startling clap that awakens",
        "lineTexts": [
            "Shock comes and the heart quails, yet afterward come laughter and ease. Good fortune, for the fright has roused a wholesome caution.",
            "Shock arrives bearing danger, and treasure is reckoned lost as one flees to the high places. Do not chase after what is gone; in seven days it returns of itself.",
            "The shock comes and leaves one dazed and unsteady. If the alarm sets one moving rightly, no misfortune comes of it.",
            "The shock comes, and one is mired, sunk fast in soft ground; nothing can stir while the spirit is bogged down.",
            "Shock comes and goes, back and forth with danger on every side. Yet nothing is truly lost; attend to the work that must not be neglected.",
            "The shock brings ruin and a wild, staring confusion; to go forward now is misfortune. Since the blow falls upon the neighbor and not yet upon oneself, there is no blame in holding back, though kinsmen may murmur."
        ]
    },
    {
        "number": 52,
        "name": {
            "chinese": "艮",
            "pinyin": "gèn",
            "english": "Keeping Still Mountain"
        },
        "bits": [
            0,
            0,
            1,
            0,
            0,
            1
        ],
        "upper": "gen",
        "lower": "gen",
        "judgment": "Keeping still in the back, so that the self is no longer felt; walking through the courtyard without perceiving the people there. To rest where resting belongs and move where movement belongs, the mind at peace with its own boundary. There is no blame.",
        "image": "Mountain rests upon Mountain, stillness doubled and unmoving. So the noble person keeps his thoughts from straying beyond the present place, holding the mind within the moment it inhabits.",
        "gloss": "Stillness that knows its own limit",
        "lineTexts": [
            "Keeping the toes still, before the first step is taken. No blame; it furthers one to remain lastingly firm.",
            "Keeping the calves still, yet the calf cannot stay the leg it follows; one is carried along against one's will, and the heart is uneasy.",
            "Keeping the hips still, holding the loins rigid until the sacrum is forced apart; such stiff and grinding restraint smothers the heart with peril.",
            "Keeping the trunk still, the body at rest. No blame, though the calm is not yet of the whole being.",
            "Keeping the jaws still, so that words are measured and orderly. Remorse disappears.",
            "Noble-hearted stillness, the quiet of one who rests in completion. Good fortune."
        ]
    },
    {
        "number": 53,
        "name": {
            "chinese": "漸",
            "pinyin": "jiàn",
            "english": "Development"
        },
        "bits": [
            0,
            0,
            1,
            0,
            1,
            1
        ],
        "upper": "xun",
        "lower": "gen",
        "judgment": "Development unfolds as the maiden is given in marriage, step by gradual step; good fortune. What ripens slowly takes lasting root, and so it furthers one to persevere in what is right. Nothing of worth is gained by haste.",
        "image": "Wind moves above the Mountain, the tree spreading slowly upon the height, growing only as the years allow. So the noble person abides in worth and virtue, refining his ways by degrees until the customs of the people are bettered.",
        "gloss": "The slow, sure ascent of the wild goose",
        "lineTexts": [
            "The wild goose draws gradually toward the shore. The young one is in peril and there is talk against it, yet there is no blame.",
            "The wild goose draws gradually toward the cliff ledge; eating and drinking in calm gladness, all is at ease. Good fortune.",
            "The wild goose draws gradually toward the high plateau. The man marches out and does not return; the woman conceives but does not bring forth. Misfortune; here it furthers one to ward off attack.",
            "The wild goose draws gradually toward the tree and finds perhaps a flat branch to rest upon. No blame, for it accepts a place not its own with patience.",
            "The wild goose draws gradually toward the summit. For three years the woman bears no child, yet in the end nothing can hinder the union; good fortune comes at last.",
            "The wild goose draws gradually toward the cloud heights, and its shed feathers may serve in the sacred dance. Good fortune; the ascent reaches the realm of order and meaning."
        ]
    },
    {
        "number": 54,
        "name": {
            "chinese": "歸妹",
            "pinyin": "guī mèi",
            "english": "The Marrying Maiden"
        },
        "bits": [
            1,
            1,
            0,
            1,
            0,
            0
        ],
        "upper": "zhen",
        "lower": "dui",
        "judgment": "The Marrying Maiden enters not as first wife but as the one who follows, drawn by impulse rather than by proper rite. To undertake action in this spirit brings misfortune, and nothing here is furthered. One must understand the transient and the flawed in such a bond.",
        "image": "Thunder stirs above the Lake, the joyous water moved by the rousing storm above it. So the noble person, knowing how things end in decay, dwells upon what lasts and guards against the rupture to come.",
        "gloss": "The younger sister who follows",
        "lineTexts": [
            "The maiden marries as a secondary wife, taking a humble place; like a lame man who can still walk, she serves where she can. To carry on so brings good fortune.",
            "A one-eyed man who can yet see something. It furthers the solitary one to hold to constancy, keeping faith even in a slighted and shadowed position.",
            "The maiden who would marry waits in servitude, and only by accepting the lesser station as a subordinate wife does she find her way. The proud waiting could not last.",
            "The marrying maiden lets the appointed time pass; a late marriage comes in its own season. Better to wait for the right hour than to seize the wrong one.",
            "The royal sovereign gives his daughter in marriage; her embroidered sleeves are plainer than the handmaid's, for true worth needs no display. The moon nearly full is most fortunate. Good fortune.",
            "The woman holds up a basket, but it is empty; the man stabs the sheep, but no blood flows. The forms are observed without substance; nothing furthers."
        ]
    },
    {
        "number": 55,
        "name": {
            "chinese": "豐",
            "pinyin": "fēng",
            "english": "Abundance"
        },
        "bits": [
            1,
            0,
            1,
            1,
            0,
            0
        ],
        "upper": "zhen",
        "lower": "li",
        "judgment": "Abundance brings success, and the king attains it at his zenith. Do not grieve that fullness cannot last; be like the sun at midday, giving light freely while it stands high. The height of plenty is brief, so let it be used well.",
        "image": "Thunder and Lightning come together, clarity and movement joined at the peak of their power. So the noble person decides lawsuits and carries out punishments, judging with brightness and acting with decisive force.",
        "gloss": "The brimming noon of fullness",
        "lineTexts": [
            "One meets the destined companion, an equal in worth; though they spend ten days together it is no error. To go forward in such union earns recognition.",
            "The screen of abundance grows so dense that at midday the polestars are seen; pressing on now would draw mistrust and hatred. Yet let inner truth shine forth, and good fortune comes.",
            "The undergrowth of abundance is so thick that at noon the smallest stars appear; the right arm is broken and cannot act. No blame, for one is simply unable, not unwilling.",
            "The tent of abundance darkens the day until the polestars show at noon, but then one meets the lord of like kind. Good fortune comes of the encounter.",
            "Lines of worth come forward, bringing blessing and praise. Good fortune.",
            "The house swells in abundance until it screens out the household; peering through the gate, one finds it still and deserted, no one seen for three years. Misfortune, for grandeur has emptied itself of life."
        ]
    },
    {
        "number": 56,
        "name": {
            "chinese": "旅",
            "pinyin": "lǚ",
            "english": "The Wanderer"
        },
        "bits": [
            0,
            0,
            1,
            1,
            0,
            1
        ],
        "upper": "li",
        "lower": "gen",
        "judgment": "The Wanderer finds modest success; in small things, perseverance brings good fortune. A stranger far from home has no rank to lean upon and must be reserved and upright in all he does. Caution and courtesy are his only shelter.",
        "image": "Fire rests upon the Mountain, burning briefly across the slope and moving on, never settling where it flares. So the noble person is clear and cautious in imposing penalties and does not let lawsuits drag on, dealing swiftly and then passing by.",
        "gloss": "The stranger far from home",
        "lineTexts": [
            "The wanderer fusses over petty things and busies himself with trifles; by such smallness he draws down disaster upon himself.",
            "The wanderer comes to an inn and carries his goods with him; he wins the loyalty of a faithful young servant, and so finds firm ground in a strange place.",
            "The wanderer burns down his lodging and loses the loyalty of his servant; perseverance now brings only danger, for he has wrecked his own shelter through carelessness.",
            "The wanderer rests in a place of refuge and gains property and an axe for protection, yet his heart is not glad; the security is uneasy, for it is not truly his own.",
            "He shoots a pheasant, and though one arrow is lost, in the end this brings praise and high office. Skill rightly shown wins favor even on the road.",
            "The bird's nest burns; the wanderer first laughs, then must cry and lament. In rashness he loses his cattle at the border. Misfortune comes to one who forgets that a stranger must keep humble."
        ]
    },
    {
        "number": 57,
        "name": {
            "chinese": "巽",
            "pinyin": "xùn",
            "english": "The Gentle Wind"
        },
        "bits": [
            0,
            1,
            1,
            0,
            1,
            1
        ],
        "upper": "xun",
        "lower": "xun",
        "judgment": "Through gentle, ceaseless influence, small success is attained. It is good to have somewhere to go, and good to seek the counsel of one who is great. What cannot be forced may yet be won by patient penetration.",
        "image": "Wind follows upon wind, the breeze that bends without breaking, entering everywhere. So the noble person spreads their commands and carries the work forward, repeating the gentle word until it takes root in the hearts of others.",
        "gloss": "Patient penetration, the wind that bends all",
        "lineTexts": [
            "Advancing and retreating in uncertainty; the resolve of a disciplined person steadies the wavering will.",
            "The wind searches beneath the bed, where hidden things gather. Calling on diviners and priests in such number brings good fortune and no blame.",
            "Penetration repeated again and again becomes mere fretting; humiliation follows the over-eager mind.",
            "Remorse vanishes here. In the hunt three kinds of game are taken; the patient pursuit yields its reward.",
            "Perseverance brings good fortune and remorse disappears. There is no beginning, but there is an end; weigh three days before, three days after, and fortune follows.",
            "The wind searches beneath the bed once more, but now both ax and means are lost. Persisting brings misfortune."
        ]
    },
    {
        "number": 58,
        "name": {
            "chinese": "兌",
            "pinyin": "duì",
            "english": "The Joyous Lake"
        },
        "bits": [
            1,
            1,
            0,
            1,
            1,
            0
        ],
        "upper": "dui",
        "lower": "dui",
        "judgment": "Joy brings success, and it is favorable to persevere. True gladness is firm within and gentle without, the kind that draws others freely toward shared labor. Such joy makes even toil and danger light to bear.",
        "image": "Lakes resting one upon the other, their waters mingling and replenishing each other endlessly. So the noble person joins with friends to study and to discuss, that joy may be deepened and renewed in good company.",
        "gloss": "Joy that gladdens and is shared",
        "lineTexts": [
            "Contented joy, quiet and without craving; good fortune attends the heart at peace with itself.",
            "Sincere joy from within brings good fortune, and all remorse melts away.",
            "Joy that comes courting from outside, seeking pleasure for its own sake; this brings misfortune.",
            "Weighing one joy against another, finding no rest; yet to draw a clear line and turn from the harmful gladness brings relief.",
            "Trusting in what would wear you down carries real danger; guard against the joy that dissolves your firmness.",
            "Joy that lures and seduces, leading others on by its charm alone, never coming to rest in truth."
        ]
    },
    {
        "number": 59,
        "name": {
            "chinese": "渙",
            "pinyin": "huàn",
            "english": "Dispersion"
        },
        "bits": [
            0,
            1,
            0,
            0,
            1,
            1
        ],
        "upper": "xun",
        "lower": "kan",
        "judgment": "Dispersion has success. The king approaches his temple, and it is favorable to cross the great water; perseverance brings reward. When the wind warms the frozen waters, what was rigid and divided melts and flows together again.",
        "image": "Wind moving over the water, scattering the ice and breathing it into motion. So the kings of old offered sacrifice to the highest powers and raised temples, gathering the dispersed hearts of the people around a common reverence.",
        "gloss": "Dissolving the hardness that divides",
        "lineTexts": [
            "Bring help while the rift is small, and bring it strongly, like a swift horse; good fortune comes from acting before division hardens.",
            "When dispersion begins, hasten to that which supports you; remorse disappears for the one who finds a refuge.",
            "Dispersing the self and its small concerns; turning outward beyond one's own ego, there is no regret.",
            "Dispersing the faction, the narrow circle of one's own party, brings supreme good fortune. From the scattering arises a greater gathering that the common mind could not foresee.",
            "Scattering abroad great proclamations like sweat, dispersing the hoarded wealth of the king; in a time of dissolution, the ruler holds firm and is without blame.",
            "Dispersing the blood that would be shed, departing far from danger and its reach; in keeping clear of harm there is no fault."
        ]
    },
    {
        "number": 60,
        "name": {
            "chinese": "節",
            "pinyin": "jié",
            "english": "Limitation"
        },
        "bits": [
            1,
            1,
            0,
            0,
            1,
            0
        ],
        "upper": "kan",
        "lower": "dui",
        "judgment": "Limitation brings success. But limitation that is galling and bitter must not be made to endure; measure has its own measure. As the seasons each keep their bound, so wise restraint shapes life into order without cruelty.",
        "image": "Water above the lake, which can hold only so much before it overflows. So the noble person sets up clear measures and degrees, and reflects upon what conduct rightly accords with them.",
        "gloss": "Restraint that gives life its shape",
        "lineTexts": [
            "One does not step beyond the courtyard door; knowing when to hold still, there is no blame.",
            "One does not step beyond the gate of the courtyard when the moment to go has come; such delay brings misfortune.",
            "Knowing no limit, the heart that finds no bound will have cause for lamentation; yet who else is there to blame?",
            "Contented limitation, restraint borne easily and without strain; this leads to success.",
            "Sweet limitation, gracious and willingly embraced, brings good fortune. Going forward in this spirit wins honor and esteem.",
            "Galling limitation, harsh and bitter; to persist in it brings misfortune, though in time the remorse may pass."
        ]
    },
    {
        "number": 61,
        "name": {
            "chinese": "中孚",
            "pinyin": "zhōng fú",
            "english": "Inner Truth"
        },
        "bits": [
            1,
            1,
            0,
            0,
            1,
            1
        ],
        "upper": "xun",
        "lower": "dui",
        "judgment": "Inner truth moves even pigs and fishes, and brings good fortune. It is favorable to cross the great water, and favorable to persevere. When sincerity fills the heart, it reaches the most stubborn and the least conscious of creatures.",
        "image": "Wind moving over the lake, stirring the surface from within so that the water answers freely. So the noble person weighs the cases of the accused with care and stays the hand of death, letting compassion guide judgment.",
        "gloss": "Sincerity that reaches the heart of things",
        "lineTexts": [
            "Being prepared within brings good fortune; if one harbors secret aims toward another, the heart finds no rest.",
            "A crane calls in the shade, and its young answers; I have a good cup, and I will share it with you. The hidden accord of true hearts needs no display.",
            "Finding a comrade: now beating the drum, now falling still, now weeping, now singing. The heart that depends wholly on another is tossed between elation and grief.",
            "The moon nearly full; the team-horse parts from its mate and goes on alone. To leave one's lesser companions and rise toward the higher is without blame.",
            "Possessing truth that binds others together as if by a cord; firm sincerity holds all in place, and there is no blame.",
            "The cockcrow that strives to reach heaven; how could such hollow show endure? Sound without substance, persisting in it, brings misfortune."
        ]
    },
    {
        "number": 62,
        "name": {
            "chinese": "小過",
            "pinyin": "xiǎo guò",
            "english": "Preponderance of the Small"
        },
        "bits": [
            0,
            0,
            1,
            1,
            0,
            0
        ],
        "upper": "zhen",
        "lower": "gen",
        "judgment": "The small holds sway, and there is success; perseverance is favorable. Small matters may be undertaken, but not great ones. The bird's song says one should descend rather than climb; in lowliness lies great good fortune.",
        "image": "Thunder upon the mountain, its sound exceeding its accustomed bounds yet kept within the peak's quiet. So the noble person leans slightly toward excess in conduct: a little more reverence in mourning, a little more thrift in spending, a little more deference in bearing.",
        "gloss": "Modest excess in small and humble things",
        "lineTexts": [
            "A bird that flies too high, beyond its strength; in overreaching at the very start, misfortune is met.",
            "Passing by the ancestor, one meets the ancestress; not reaching the prince, one meets the minister instead. Staying within proper measure, there is no blame.",
            "If one is not exceedingly careful, someone may strike from behind; without watchful caution, misfortune follows.",
            "Without blame, but meet the matter without forcing past it. Going on would bring danger; one must hold firm and not act, persevering in restraint.",
            "Dense clouds, yet no rain, drifting from the western field; the prince shoots and takes the one already in the cave. The small cannot bring the great work to fruition.",
            "Passing beyond and missing the mark, the bird flying ever away; this is misfortune, and is called calamity and self-inflicted ruin."
        ]
    },
    {
        "number": 63,
        "name": {
            "chinese": "既濟",
            "pinyin": "jì jì",
            "english": "After Completion"
        },
        "bits": [
            1,
            0,
            1,
            0,
            1,
            0
        ],
        "upper": "kan",
        "lower": "li",
        "judgment": "After completion brings success in small matters, and perseverance is favorable. At the outset all is in order and fortune smiles; but at the end disorder threatens. The work is done, yet the danger now is in believing nothing more need be guarded.",
        "image": "Water set above fire, each in its place, the cauldron brought at last to the boil. So the noble person, mindful that order tends toward decay, considers misfortune before it comes and arms against it in advance.",
        "gloss": "The work fulfilled, yet vigilance required",
        "lineTexts": [
            "He brakes his wheels and gets his tail in the water; holding back at the crossing, there is no blame.",
            "The woman loses the curtain of her carriage; do not chase after it, for in seven days it will return of itself.",
            "The Illustrious Ancestor subdues the lands of the demon country; after three years he prevails. Such a great undertaking is not for lesser people to attempt.",
            "Even the finest garments will have rags to stop the leaks; be wary all day long, for the seams are already loosening.",
            "The neighbor in the east who slays an ox does not gain as much real blessing as the neighbor in the west with a small offering; sincerity outweighs splendor.",
            "He gets his head in the water; danger at the very last. To linger at the summit of completion is perilous."
        ]
    },
    {
        "number": 64,
        "name": {
            "chinese": "未濟",
            "pinyin": "wèi jì",
            "english": "Before Completion"
        },
        "bits": [
            0,
            1,
            0,
            1,
            0,
            1
        ],
        "upper": "li",
        "lower": "kan",
        "judgment": "Before completion brings success. But the little fox, almost across the stream, wets its tail; nothing then is favorable. When the crossing is nearly won, caution to the very end decides whether it is won at all.",
        "image": "Fire above water, the two not yet joined in their proper working, each pulling its own way. So the noble person takes great care to distinguish things by their natures, setting each in its rightful place before the order can be made whole.",
        "gloss": "The crossing not yet won, order forming",
        "lineTexts": [
            "He gets his tail in the water; pushing on now, before strength is gathered, brings humiliation.",
            "He brakes his wheels and holds back; perseverance in this restraint brings good fortune.",
            "Before completion, to set forth now brings misfortune; yet it is favorable to cross the great water once the time is ripe.",
            "Perseverance brings good fortune and remorse vanishes. With great force one subdues the demon country, and after three years there are rewards in the great kingdom.",
            "Perseverance brings good fortune and no remorse. The light of the noble person is true, and its radiance brings good fortune through sincerity.",
            "With genuine confidence one may drink wine, and there is no blame; but if one wets the head in heedless excess, even confidence loses its right measure."
        ]
    }
];
//# sourceMappingURL=hexagram-data.js.map